import axios from 'axios';
import router from '@/router';
import Store from '@/store/index';
import config from '@/config/config';
const { apiUrl, apiProtocol } = config;
const serverUrl = process.env.SERVER_URL;
// let localServerUrl = location.protocol + '//' + location.host
// localServerUrl += ':8080'
const localServerUrl = apiProtocol ? apiProtocol + '://' + location.host + ':8080' : apiUrl;
const url = serverUrl === 'false' ? localServerUrl : serverUrl;
const instance = axios.create({
    baseURL: url + '/api/',
    withCredentials: true,
    headers: {}
});
instance.interceptors.request.use(config => {
    Store.commit('common/SetLoading', true);
    const token = Store.state.auth.token;
    // console.log(token)
    token ? (config.headers.Authorization = 'Bearer ' + token) : (delete config.headers.Authorization);
    // if (config.method === 'post' || config.method === 'put') {
    //   config.data = JSON.stringify(config.data)
    // }
    return config;
}, (error) => {
    return Promise.reject(error);
});
instance.interceptors.response.use(function (response) {
    // Do something with response data
    setTimeout(() => Store.commit('common/SetLoading', false), 500);
    return response.data;
}, async function (error) {
    const { response } = error;
    setTimeout(() => Store.commit('common/SetLoading', false), 500);
    if (response) {
        errorHandle(response);
        // 03/31如果狀態碼是 401，就回傳一個永遠不會被解析的 Promise 來中斷後續操作
        if (response.status === 401) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return new Promise(() => { });
        }
        return Promise.reject(error);
    }
    else {
        if (!window.navigator.onLine) {
            console.log('網路問題');
        }
        else {
            // 跨域或程式問題
            return Promise.reject(error);
        }
    }
});
export default function (method, url, data = null, config = { headers: {} }) {
    method = method.toLowerCase();
    switch (method) {
        case 'post':
            config.headers = { Authorization: 'Bearer' };
            return instance.post(url, data, config);
        case 'get':
            return instance.get(url, { params: data });
        case 'put':
            return instance.put(url, data);
        case 'patch':
            return instance.patch(url, data);
        case 'del':
            console.log(data);
            return instance.delete(url, data);
        default:
            console.log(`未知的 method: ${method}`);
            return false;
    }
}
const errorHandle = (response) => {
    const { status, data } = response;
    console.log('response', response, data);
    const jsonData = data;
    // if (data?.type === 'application/json') {
    //   // 轉回 JSON
    //   try {
    //     const text = await data.text()
    //     jsonData = JSON.parse(text)
    //   } catch (e) {
    //     console.error('解析 JSON 失敗', e)
    //   }
    // }
    // console.log('jsonData', jsonData)
    switch (status) {
        case 401:
            // 身分驗證失敗
            Store.dispatch('message/setSnackbar', {
                show: true,
                // 03/31 add
                text: jsonData.message ? jsonData.message : 'LOGINERROR_1'
                // text: 'LOGINERROR_1'
            }).then(() => {
                if (router.currentRoute.path !== '/') {
                    Store.dispatch('auth/setAuth', {
                        token: '',
                        isLogin: false
                    });
                }
            });
            break;
        case 403:
            // 登入失敗
            Store.dispatch('message/setSnackbar', {
                show: true,
                text: jsonData.message ? jsonData.message : 'LOGINERROR_2'
                // text: 'LOGINERROR_2'
            });
            if (jsonData.message !== 'Access Denied') {
                window.location.href = '/403.html';
            }
            break;
        case 404:
            // 請求失敗
            Store.dispatch('message/setSnackbar', {
                show: true,
                text: jsonData.message ? jsonData.message : '請求失敗'
            });
            break;
        case 500:
            break;
        default:
            Store.dispatch('message/setSnackbar', {
                show: true,
                text: jsonData?.message,
                type: 'text'
            });
            console.log('未知錯誤');
            window.location.href = '/403.html';
    }
};
